import React from 'react';

const BicycleCard = ({ bicycle, onClick }) => {
  return (
    <div 
      className={`bicycle-card ${bicycle.sold ? 'sold' : ''}`}
      onClick={() => onClick(bicycle)}
    >
      <div className="bicycle-image">
        <img src={bicycle.imagePath} alt={bicycle.title} />
        {bicycle.sold && <div className="sold-overlay">SOLD</div>}
      </div>
      <div className="bicycle-info">
        <h3 className="bicycle-title">{bicycle.title}</h3>
        <p className="bicycle-price">
          {bicycle.sold ? (
            <span className="out-of-stock">Out of Stock</span>
          ) : (
            <>
              <span>Rent till semester end: ₹{bicycle.priceRental}</span>
              <span>Buy: ₹{bicycle.priceSelling}</span>
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default BicycleCard;